import SignaturePad from 'signature_pad'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['canvas', 'imgContainer', 'input']
  /* ----- LIFECYCLE CALLBACKS ----- */

  connect () {
    this.signaturePad = new SignaturePad(this.canvasTarget);
  }

  onEraserClick(event) {
    event.preventDefault()
    this.signaturePad.clear();
  }

  onSaveClick(event) {
    event.preventDefault()
    if (this.signaturePad.isEmpty()) {
      alert("Please provide a signature first.");
    } else {
      var dataURL = this.signaturePad.toDataURL();
      this.inputTarget.value = dataURL;
      this.imgContainerTarget.innerHTML = '<p>Aperçu :</p><img src="' + dataURL + '" alt="Aperçu" title="Aperçu">';
    }
  }

  addImageToEditor(event) {
    event.preventDefault()
    if (!window.editor) {
      alert("Editor not found.")
      return
    }

    if (this.signaturePad.isEmpty()) {
      alert("Please provide a signature first.")
      return
    }

    const dataURL = this.signaturePad.toDataURL()
    const model = window.editor.model
    
    model.change(writer => {
      const root = model.document.getRoot()
      const insertPosition = writer.createPositionAt(root, 'end')
      
      const imageElement = writer.createElement('imageBlock', {
        src: dataURL,
        alt: 'Signature',
        width: '300px'  
      })

      writer.insert(imageElement, insertPosition)
    })
  }
}
